import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

/**
 * Initialize the application
 * 
 * - Renders the root application component
 * - Theme is now managed by ThemeProvider
 */

// Find the root element for React to render into
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found in document');
}

// Create and render the React application
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
